import { render, staticRenderFns } from "./CartSkeletonFooter.vue?vue&type=template&id=cf2b4c2c&scoped=true&"
import script from "./CartSkeletonFooter.vue?vue&type=script&lang=js&"
export * from "./CartSkeletonFooter.vue?vue&type=script&lang=js&"
import style0 from "./CartSkeletonFooter.vue?vue&type=style&index=0&id=cf2b4c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2b4c2c",
  null
  
)

export default component.exports